// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");

var wrapper = "relative inline-block";

var xSmallIconStyle = "absolute left-[25px] top-[21px] opacity-40";

var smallIconStyle = "absolute left-[34px] top-[29px] opacity-40";

var mediumIconStyle = "absolute left-[38px] top-[33px] opacity-40";

var largeIconStyle = "absolute left-[57px] top-[49px] opacity-40";

function TerminatedAgentIconOverlay(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsxs("span", {
              children: [
                size === "xLarge" ? JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsx(Icon__Jsx3.make, {
                              icon: "Unavailable",
                              size: 36,
                              color: Theme__Color__Vars.crimson
                            }),
                        className: largeIconStyle
                      }) : (
                    size === "medium" ? JsxRuntime.jsx("span", {
                            children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                  icon: "Unavailable",
                                  size: 24,
                                  color: Theme__Color__Vars.crimson
                                }),
                            className: mediumIconStyle
                          }) : (
                        size === "small" ? JsxRuntime.jsx("span", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Unavailable",
                                      size: 20,
                                      color: Theme__Color__Vars.crimson
                                    }),
                                className: smallIconStyle
                              }) : (
                            size === "xSmall" ? JsxRuntime.jsx("span", {
                                    children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                          icon: "Unavailable",
                                          size: 18,
                                          color: Theme__Color__Vars.crimson
                                        }),
                                    className: xSmallIconStyle
                                  }) : JsxRuntime.jsx("span", {
                                    children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                          icon: "Unavailable",
                                          size: 36,
                                          color: Theme__Color__Vars.crimson
                                        }),
                                    className: largeIconStyle
                                  })
                          )
                      )
                  ),
                props.children
              ],
              className: wrapper
            });
}

var Icon;

var make = TerminatedAgentIconOverlay;

exports.wrapper = wrapper;
exports.xSmallIconStyle = xSmallIconStyle;
exports.smallIconStyle = smallIconStyle;
exports.mediumIconStyle = mediumIconStyle;
exports.largeIconStyle = largeIconStyle;
exports.Icon = Icon;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
